import api from './default'

export default api('/api/gradebook', 'gradebooks')
